document.addEventListener("DOMContentLoaded", async () => {
    // ======================
    // DOM Element References
    // ======================
    const scrollableElement = document.querySelector('.real-life-scroll');
    const stickyContainer = document.querySelector('.real-life-scrolling-content-container');
    const stickyImages = document.querySelectorAll('.real-life-scroll-panel.web .real-life-scroll-panel-image');

    // ==============
    // Configuration
    // ==============
    const IMAGE_COUNT = stickyImages.length - 1;
    const SCROLL_OFFSET = 28; // Adjusts scroll trigger point
    const SECTION_HEIGHT = 1.2*window.innerHeight; // Height per scroll section
    const MARGIN = 0.5*window.innerHeight; // Transition margin before/after main scroll
    const BORDER_RADIUS_MAX = 24; // Maximum container corner rounding
    const HEIGHT_OFFSET = 105; // Additional space for scroll container
    
    const SCROLLABLE_HEIGHT = 2 * MARGIN + IMAGE_COUNT * SECTION_HEIGHT;

    // ==============
    // State Tracking
    // ==============
    let currentScrollPosition;
    let containerBaseWidth;
    let containerBaseHeight;
    let scrollableElementTop;
    let active = false;

    // ==================
    // Core Functionality
    // ==================
    function updateLayoutMetrics() {
        scrollableElementTop = scrollableElement.offsetTop;
        containerBaseWidth = stickyContainer.clientWidth / window.innerWidth;
        containerBaseHeight = stickyContainer.clientHeight / window.innerHeight;
        
        // Set scrollable area height
        scrollableElement.style.height = `
            ${SCROLLABLE_HEIGHT + stickyContainer.clientHeight + HEIGHT_OFFSET}px
        `;
    }

    function getNormalizedScrollPosition(rawScroll) {
        return rawScroll - scrollableElementTop - SCROLL_OFFSET;
    }

    function updateContainerScale(progress) {
        const scaleFactor = progress / MARGIN;
        const widthScale = containerBaseWidth + (1 - containerBaseWidth) * scaleFactor;
        const heightScale = containerBaseHeight + (1 - containerBaseHeight) * scaleFactor;

        stickyContainer.style.width = `calc(${widthScale * 100}vw)`;
        // stickyContainer.style.maxWidth = `calc(${widthScale * 100}vw)`;
        stickyContainer.style.height = `calc(${heightScale * 100}vh)`;
        stickyContainer.style.borderRadius = `
            ${BORDER_RADIUS_MAX * (1 - scaleFactor)}px
        `;
    }

    // =====================
    // Scroll Effect Handlers
    // =====================
    function handleTopMarginScroll() {
        updateContainerScale(currentScrollPosition);
        stickyImages[0].style.clipPath = 'inset(0 0 0 0)';
    }

    function handleMiddleScroll() {
        const currentSection = Math.floor((currentScrollPosition - MARGIN) / SECTION_HEIGHT);
        const scrollProgress = (
            (currentScrollPosition - MARGIN - currentSection * SECTION_HEIGHT) * 100
        ) / SECTION_HEIGHT;

        // Update current section
        stickyImages[currentSection].style.clipPath = `inset(0 ${scrollProgress}% 0 0)`;
        
        // Clear previous section
        if (currentSection > 0) {
            stickyImages[currentSection - 1].style.clipPath = 'inset(0 100% 0 0)';
        }
        
        // Prepare next section
        if (currentSection < IMAGE_COUNT - 1) {
            stickyImages[currentSection + 1].style.clipPath = 'inset(0 0 0 0)';
        }
    }

    function handleBottomMarginScroll() {
        if(IMAGE_COUNT != 0)stickyImages[IMAGE_COUNT - 1].style.clipPath = 'inset(0 0 0 100%)';
        updateContainerScale(SCROLLABLE_HEIGHT - currentScrollPosition);
    }

    function manageScrollEffects() {
        if (currentScrollPosition <= MARGIN) {
            handleTopMarginScroll();
        } else if (currentScrollPosition <= SCROLLABLE_HEIGHT - MARGIN) {
            handleMiddleScroll();
        } else {
            handleBottomMarginScroll();
        }
    }

    // ======================
    // Container Positioning
    // ======================
    function updateContainerPosition() {
        if (currentScrollPosition < 0) {
            // Before sticky effect starts
            stickyContainer.style.position = 'relative';
            stickyContainer.style.top = '0';
            stickyContainer.style.transform = 'unset';
            active = false
        } else if (currentScrollPosition <= SCROLLABLE_HEIGHT) {
            if(!active){    
                updateLayoutMetrics();
                active = true;
            }
            // During main scroll effect
            stickyContainer.style.position = 'fixed';
            stickyContainer.style.top = '50%';
            stickyContainer.style.transform = 'translateY(-50%)';
            manageScrollEffects();
        } else {
            active = false
            // After sticky effect ends
            stickyContainer.style.position = 'absolute';
            stickyContainer.style.bottom = '0';
            stickyContainer.style.top = 'auto';
            stickyContainer.style.transform = 'unset';
        }
    }

    // ================
    // Scroll Handling
    // ================
    function processScroll() {
        currentScrollPosition = getNormalizedScrollPosition(window.scrollY);
        updateContainerPosition();
        requestAnimationFrame(processScroll);
    }

    // ==============
    // Initialization
    // ==============
    function initializeScrollEffect() {
        if (window.innerWidth > 1080) {
            updateLayoutMetrics();
            processScroll();
        } else {
            cancelAnimationFrame(processScroll);
        }
    }

    // ================
    // Event Listeners
    // ================
    if(scrollableElement.style.display != 'none')window.addEventListener('resize', initializeScrollEffect);
    initializeScrollEffect();
});
